import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { Cabinet } from '../types/fyi-docs';

type GetFYICabinetsRequest = {
    page: number;
    limit: number;
};

type GetFYICabinetsResponse = {
    cabinets: Cabinet[];
    totalItems: number;
};
async function getFYICabinets(params: GetFYICabinetsRequest): Promise<GetFYICabinetsResponse> {
    const { data } = await api.get('/fyi-docs/cabinets', { params });
    return data;
}

export function useFYICabinets(params: GetFYICabinetsRequest): UseQueryResult<GetFYICabinetsResponse, unknown> {
    return useQuery(['fyi', 'cabinets', params.limit, params.page], () => getFYICabinets(params), {
        keepPreviousData: true,
    });
}
